import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { AdminQueryKeys, getPlatformMetrics, type PlatformMetricsResponse } from '../api';

export function usePlatformMetrics(): UseQueryResult<PlatformMetricsResponse> {
  return useQuery({
    queryKey: AdminQueryKeys.metrics(),
    queryFn: ({ signal }) => getPlatformMetrics(signal),
    staleTime: 60_000,
  });
}
